<template>
	<div>
		<div class="main">
			<SmartphonePreviewComponent :background-image="backgroundImage" :special-offer="specialOffer" :video-content="videoContent" />
		</div>
	</div>
</template>

<script>
import { RepairshopsApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import Validate from '@/mixins/Validate';
import { getGermanDate } from '@/plugins/Utils';
import Authentication from '@/mixins/Authentication';
import SmartphonePreviewComponent from '@/views/management/RepairShop/Ads/SmartphonePreviewComponent.vue';
import SpecialOfferRepository from '@/api/repositories/SpecialOfferRepository';
import SpecialOfferTemplateRepository from '@/api/repositories/SpecialOfferTemplateRepository';

export default {
	name: 'AdPreview',
	components: { SmartphonePreviewComponent },
	mixins: [Validate, Authentication],
	data() {
		return {
			specialOffer: {},
			backgroundImage: null,
			videoContent: null,
			isLoaded: false,
		};
	},
	methods: {
		getGermanDate,
		getAdByID() {
			if (this.$route.path.includes('ad_templates')) {
				new SpecialOfferTemplateRepository().getTemplateById(this.specialOffer.id).then(response => {
					if (response.data.data != null) {
						this.specialOffer = response.data.data;
						if (response.data.data.media?.type === 'video') {
							this.videoContent = response.data.data.media.base64content;
						} else if (response.data.data.media?.type === 'image') {
							this.backgroundImage = response.data.data.media.base64content;
						}
					}
				});
			} else {
				RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.specialOffersIdGet(this.specialOffer.id)
					.then(response => {
						if (response.data.data != null) {
							this.specialOffer = response.data.data;
							if (response.data.data.media?.type === 'video') {
								this.videoContent = response.data.data.media.base64content;
							} else if (response.data.data.media?.type === 'image') {
								this.backgroundImage = response.data.data.media.base64content;
							}
							this.specialOffer.start = new Date(response.data.data.start);
							this.specialOffer.end = new Date(response.data.data.end);
						}
					});
			}
		},
	},
	mounted() {
		if (!this.isUserAllowedInLevel5or6 && !this.isUserAllowedInLevel1) {
			this.$emit('authNotAllowed');
		} else {
			if (this.$route.params.id != null) {
				this.specialOffer.id = this.$route.params.id;
				this.getAdByID();
			}
		}
	},
	watch: {
		'specialOffer.image': function() {
			this.backgroundImage = this.specialOffer.image;
		},
	},
};
</script>

<style scoped></style>
